function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import React, { useState, useEffect, useMemo } from 'react';
import { PropTypes } from 'prop-types';
import classnames from 'classnames';
import { testidFactory } from "../../../utils/testid";
import { useScroll } from "../../../hooks/useScroll";
import { HorizontalMenu } from "../HorizontalMenu";
import { getActiveOnScroll } from "./utils/getActiveOnScroll";
var TEST_ID_PREFIX = 'stickyMenu';
var testid = testidFactory(TEST_ID_PREFIX);
export var Component = function Component(_ref) {
  var className = _ref.className,
      stickyMenuItems = _ref.stickyMenuItems,
      hasOverflow = _ref.hasOverflow;

  var _useState = useState(''),
      _useState2 = _slicedToArray(_useState, 2),
      activeItem = _useState2[0],
      setActiveItem = _useState2[1];

  useEffect(function () {
    if (stickyMenuItems.length > 0) {
      setActiveItem(stickyMenuItems[0].text);
    }

    if (activeItemOnScroll) {
      setActiveItem(activeItemOnScroll);
    }
  });
  var activeItemOnScroll = useScroll(function () {
    return getActiveOnScroll(stickyMenuItems);
  }, 0, 0);

  var scrollToComponentOnMenuClick = function scrollToComponentOnMenuClick(_ref2, event) {
    var link = _ref2.link,
        text = _ref2.text;
    event.preventDefault();
    setActiveItem(text);
    document.querySelector(link).scrollIntoView({
      behavior: 'smooth'
    });
    window.history.pushState('', '', link);
  };

  var items = useMemo(function () {
    return stickyMenuItems.map(function (item) {
      return _objectSpread(_objectSpread({}, item), {}, {
        isActive: item.text === activeItemOnScroll || item.text === activeItem
      });
    });
  }, [activeItemOnScroll, activeItem, stickyMenuItems.length]);
  return React.createElement(HorizontalMenu, {
    className: classnames(className, 'sticky-menu'),
    "data-testid": testid(),
    hasOverflow: hasOverflow,
    items: items,
    onItemClick: scrollToComponentOnMenuClick
  });
};
Component.displayName = 'StickyMenu';
Component.defaultProps = {
  className: null,
  hasOverflow: false,
  stickyMenuItems: []
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  className: PropTypes.string,
  hasOverflow: PropTypes.bool,
  stickyMenuItems: PropTypes.arrayOf(PropTypes.shape({
    link: PropTypes.string.isRequired,
    text: PropTypes.string.isRequired
  }))
} : {};